import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const usePreviewButton = ({ GTMEvent, watchPreview }) => {
	const { t } = useTranslation();
	const { pathname } = useLocation();
	const ref = useRef();

	const buttonText = t('vod_buttons_preview');

	const handleClick = () => {
		watchPreview();
		GTMEvent && GTMEvent({ pathname, label: buttonText });
	};
	return {
		handleClick,
		buttonText,
		ref
	};
};

export default usePreviewButton;
